import styled from 'styled-components';
import Card from './Card';

const ExpandableCard = styled(Card)<{ expanded?: boolean }>`
    overflow: visible;
    ${props =>
        props.expanded &&
        `
        width: 100vw;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        border-left: none;
        border-right: none;
        border-radius: 0;
    `}
`;

export default ExpandableCard;
